<template>
  <v-layout column>    
    <v-flex xs11 offset-xs0>
      <panel v-bind:title='title'>
        
        <div slot="top">
          <v-tabs >

            <v-tab>Born</v-tab>
            <v-tab>Living at enlistment</v-tab>
            <v-tab>Enlisted</v-tab>
            <v-tab>Home Port</v-tab>
            <v-tab>On Honour Roll</v-tab>
            <v-tab>About {{place.v}}</v-tab>

            <!-- lazy on the tab-item stops preloading - more efficient? -->
            <v-tab-item >
              <PeopleSearchTable v-bind:forceBirthPlaceId="id"/>
            </v-tab-item>
            <v-tab-item >
              <PeopleSearchTable v-bind:forceEnlistAddressPlaceId="id"/>
            </v-tab-item>
            <v-tab-item >
              <PeopleSearchTable v-bind:forceEnlistPlaceId="id"/>
            </v-tab-item>
            <v-tab-item >
              <PeopleSearchTable v-bind:forceHomePortPlaceId="id"/>
            </v-tab-item>             
            <v-tab-item >
              <PeopleSearchTable v-bind:forceHonourRollPlaceId="id"/>
            </v-tab-item>   
            <v-tab-item>
              <div v-if="place.parent" class='section'>
                <H3>{{ place.v }} is part of </H3>
                  <router-link :to="{path: '/place/' + place.parent.id}">{{ place.parent.v
                 }}</router-link><span v-if="place.parent.parent">, 
                    <router-link :to="{path: '/place/' + place.parent.parent.id}">
                    {{ place.parent.parent.v }}</router-link></span>
              </div>
              <div v-if="place.children && (place.children.length > 0)" class='section'>
                 <H3>Places that are part of {{ place.v }}</H3>
                  <div v-for="child in place.children" v-bind:key="child.id">
                    <router-link :to="{path: '/place/' + child.id}">{{ child.v }}</router-link>
                  </div>
              </div>
            </v-tab-item>         
            
          </v-tabs>       
        </div>         
      </panel>
            
    </v-flex>
  </v-layout>
  
</template>

<script>

import Panel from "@/components/Panel" ;
import PeopleSearchTable from "@/components/PeopleSearchTable" ;
import PlaceService from "@/services/PlaceService" ;

export default {
  components: {
    Panel, PeopleSearchTable
  },
  data () {
    return {
      id: parseInt(this.$route.params.id),
      place: {},
      title: "Loading Place " + this.$route.params.id
    }
  },
  async mounted () {
    console.log("in place mounted") ;
    await this.readData() ;
  },
  methods: {
    async readData () {

      const result = await PlaceService.id(this.id) ;
      this.place = result.data ;
      // console.log("Back from us, this.unit=" + JSON.stringify(result)) ;
      this.title = this.renderFullPlacename(this.place) ;
    },
    renderFullPlacename (place) {  // our name, then parents

      var n = place.v ;
      var parent = place.parent ;
      while (parent) {
        n += ", " + parent.v ;
        parent = parent.parent ;        
      }
      return n ;
    }
  }
};
</script>

<style scoped>
.section {margin-top:1em;font-size:120%}
</style>



// WEBPACK FOOTER //
// src/components/Place.vue